export default {
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      invoiceHeadType: 'C'
    };
  },
  mounted() {},
  methods: {
    invoiceHeadChange(val) {
      this.invoiceHeadType = val;
    }
  }
};